/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Advantage_VoicesInputs */

const en_plan_advantage_voices = /** @type {(inputs: Plan_Advantage_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium voices, read-along, and sharing`)
};

const es_plan_advantage_voices = /** @type {(inputs: Plan_Advantage_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voces premium, lectura simultánea y compartir`)
};

/**
* | output |
* | --- |
* | "Premium voices, read-along, and sharing" |
*
* @param {Plan_Advantage_VoicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_advantage_voices = /** @type {((inputs?: Plan_Advantage_VoicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Advantage_VoicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_advantage_voices(inputs)
	return en_plan_advantage_voices(inputs)
});